import { Client, Transport, Chain, Account } from "viem";

export const mockWS = "mud";

export type ConnectedClient = Client<Transport, Chain, Account>;
